// Generated by Melange

import * as Buhta_cabinet__Input from "../../html/Input.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import SearchSvg from "static/icons/search.svg";

function make(className) {
  return function (onSearchOpt) {
    const onSearch = onSearchOpt !== undefined ? onSearchOpt : (function (param) {
          
        });
    return function (childrenOpt) {
      const children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
      const match = React.useState(function () {
            return "";
          });
      const setSearchText = match[1];
      const handleSearch = function (value) {
        Curry._1(setSearchText, (function (param) {
                return value;
              }));
        Curry._1(onSearch, value);
      };
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(SearchSvg, {
                                  alt: "icon"
                                }),
                            JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                  value: match[0],
                                  placeholder: "Поиск...",
                                  type_: "text",
                                  onChange: handleSearch
                                })
                          ],
                          className: "grow grid grid-cols-auto-1 gap-x-1 items-center"
                        }),
                    JsxRuntime.jsx("div", {
                          children: children,
                          className: "flex items-center space-x-4"
                        })
                  ],
                  className: Cn.fromList({
                        hd: "flex items-center border-b border-gray-main py-4 px-6 h-14",
                        tl: {
                          hd: Cn.take(className),
                          tl: /* [] */0
                        }
                      })
                });
    };
  };
}

function TableSearchRow(Props) {
  return Curry._1(make(Props.className)(Props.onSearch), Props.children);
}

const make$1 = TableSearchRow;

export {
  make$1 as make,
}
/* Buhta_cabinet__Input Not a pure module */
